import React, { FormEvent, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

interface GuestDocumentEmailPromptProps {
  show: boolean;
  initialEmail: string;
  onHide: () => void;
  onSave: (email: string) => void;
}

const GuestDocumentEmailPrompt = ({
  show,
  initialEmail,
  onHide,
  onSave,
}: GuestDocumentEmailPromptProps) => {
  const [email, setEmail] = useState(initialEmail);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (show) setEmail(initialEmail);
  }, [initialEmail, show]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const normalizedEmail = email.trim();

    if (!normalizedEmail || !emailInputRef.current?.checkValidity()) {
      emailInputRef.current?.reportValidity();
      return;
    }

    onSave(normalizedEmail);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      onEntered={() => titleRef.current?.focus()}
      centered
      id="guest-email-modal"
      aria-labelledby="guest-email-modal-title"
      aria-describedby="guest-email-modal-description"
    >
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title
            as="h2"
            id="guest-email-modal-title"
            ref={titleRef}
            tabIndex={-1}
          >
            Where should we send your file?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p id="guest-email-modal-description">
            Enter your email to receive the converted file.
          </p>
          <label htmlFor="guest-document-email">Email address</label>
          <input
            ref={emailInputRef}
            id="guest-document-email"
            className="form-control"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
            required
          />
          <div className="guest-email-actions">
            <button type="submit">Continue</button>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
};

export default GuestDocumentEmailPrompt;
